import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  ApplicationSettings,
  ApplicationSettingService,
  BarChartDatePeriod,
  BaseComponent,
  BaseEditFormComponent,
  FormlyService,
  GridService,
  MenuService,
  ProductPurchaseOrderHistory,
  StockEnquiryService,
} from 'tms-lib';
import { StockSearch } from '../../../models';

@Component({
  selector: 'app-stock-enquiry-purchase-order-history',
  templateUrl: './stock-enquiry-purchase-order-history.component.html',
  styleUrl: './stock-enquiry-purchase-order-history.component.scss',
})
export class StockEnquiryPurchaseOrderHistoryComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;

  model$: Observable<ProductPurchaseOrderHistory[]> = of([]);

  @Input() productId: string;

  fields: FormlyFieldConfig[];
  model: StockSearch;

  columnDefs: ColDef[] = [
    this.gridService.text('orderNo', $localize`Order Number`, {
      aggFunc: AggFunc.first,
      rowGroup: true,
      hide: true,
    }),
    this.gridService.date('orderDate', $localize`Order Date`, { aggFunc: AggFunc.first }),
    this.gridService.text('supplierKey', $localize`Supplier`, { aggFunc: AggFunc.first }),
    this.gridService.text('supplierName', $localize`Name`, { aggFunc: AggFunc.first }),
    this.gridService.text('currencyCode', $localize`Currency`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderQuantity', $localize`Order Quantity`, {
      aggFunc: AggFunc.first,
      groupAggFunc: AggFunc.sum,
    }),
    this.gridService.numberFormat('orderPrice', $localize`Order Price`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderValue', $localize`Order Value`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderSterlingValue', $localize`Order Value (£)`, {
      aggFunc: AggFunc.first,
      groupAggFunc: AggFunc.sum,
    }),
    this.gridService.text('orderStatus', $localize`Order Status`, { aggFunc: AggFunc.first }),
    this.gridService.text('stockNo', $localize`Stock Number`),
    this.gridService.numberFormat('quantityReceived', $localize`Quantity Received`, {
      aggFunc: AggFunc.sum,
    }),
    this.gridService.text('invoiceNo', $localize`Invoice Number`),
    this.gridService.date('invoiceDate', $localize`Invoice Date`),
    this.gridService.numberFormat('invoicePrice', $localize`Invoice Price`),
    this.gridService.text('deliveryAddress', $localize`Delivery Address`, { aggFunc: AggFunc.first }),
    this.gridService.date('promisedDate', $localize`Promised Date`, {
      aggFunc: AggFunc.first,
    }),
  ];
  barChartPeriod = BarChartDatePeriod.Year;

  constructor(
    public stockEnquiryService: StockEnquiryService,
    private applicationSettingService: ApplicationSettingService,
    private formlyService: FormlyService,
    private menuService: MenuService,
    private gridService: GridService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.model = { search: '' };
    if (!this.productId) {
      this.productId = this.route.snapshot.paramMap.get('id');
    }
    this.getFields();
    this.applicationSettingService
      .getBoolean(ApplicationSettings.autoLoadEnquiries)
      .pipe(takeUntil(this.destroy$))
      .subscribe((autoLoadEnquiries: boolean) => {
        if (autoLoadEnquiries) {
          this.getModel();
        }
      });
  }

  private getFields() {
    const fields = [];
    if (!this.menuService.isReadOnly) {
      fields.push(
        this.formlyService.search('search', undefined, undefined, undefined, { search: () => this.getModel() }),
      );
    }

    this.fields = fields;
  }

  getModel() {
    this.model$ = this.stockEnquiryService.getStockEnquiryPurchaseOrderHistory(this.productId, this.model.search);
  }
}
